import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';


const About = () => {



  return (
    <div>

      <div className='mt-10 text-center px-3' data-aos="fade-up" data-aos-easing="linear" data-aos-duration="500" data-aos-delay="350">
        <h1 className='text-xl font-bold underline text-main'>
          קצת עליי
        </h1>
        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' dir='rtl'>
          סטודיו  פז פילאטיס בחולון                 </p>
        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' dir='rtl'>
          הנו סטודיו איכותי ומקצועי הפועל באווירה אינטימית ויחס אישי.
        </p>
        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' dir='rtl'>
          השיעורים מתבצעים בקבוצות קטנות עד 7 מתאמנות.
        </p>
        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' dir='rtl'>
          אני מתאימה את סוג האימון לפי יכולות ומגבלות ומאמינה בחיבור וגמישות הגוף והנפש.
        </p>
        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' dir='rtl'>
          כל שיעור בנוי כך שהוא מאפשר שילוב של תירגול מתוך הקשבה לצרכים שלכם ולא להיפך.בסטודיו מגוון שיעורים מחולקים לפי רמות ודרגות קושי שונות.
        </p>
        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' dir='rtl'>
          סגנון העבודה בסטודיו נאמן לשיטת הפילאטיס השיקומי  אך יחד עם זאת מאופיין בהתפתחות וחידושים המטפחים את  חיזוק הגוף ועבודת שרירי הליבה העמוקים עד כדי חיטוב ועיצוב.
        </p>
        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' dir='rtl'>
          בנוסף בסטודיו מתקיימים שיעורי יוגה לכל הרמות,בשיתוף עם יועצת תזונה לאורח חיים בריא.
        </p>
        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' dir='rtl'>
          ניתן למצוא אותנו  גם באפליקציית מכבי <b>UPPAPP</b> ולהירשם אצלנו לשיעורים שישפרו את אורח חייכם.    
              </p>



        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' dir='rtl'>
          <span className='font-bold'>אני מזמינה אתכם ליצור איתי קשר בלחיצת כפתור פשוטה
          </span>
        </p>
      </div>

    </div>

  )

}


export default About